
import { Vue, Component, Prop } from "vue-property-decorator";
import DownloadExport from "@/components/DownloadExport.vue";
import Loader from "@/components/Loader.vue";
import DateRangeSlider from "@/components/DateRangeSlider.vue";

interface DownloadType {
  name: string;
  label: string;
  dateRange: boolean;
}

@Component({ components: { DownloadExport, Loader, DateRangeSlider } })
export default class Download extends Vue {
  @Prop({ required: true })
  id!: string;

  type: DownloadType | null = null;
  dateRange = ["", ""];

  get defaultRules(): ((v: any) => boolean | string)[] {
    return [v => !!v || "Erforderliche Angabe"];
  }

  get types(): DownloadType[] {
    return [
      {
        name: "messstellen_wasserstand_hauptwerte",
        label: "Hauptwerte",
        dateRange: false
      },
      {
        name: "messstellen_wasserstand_messwerte",
        label: "Aktuelle Wasserstände (90 Tage)",
        dateRange: false
      },
      {
        name: "messstellen_wasserstand_abfluss",
        label: "Aktuelle Abflüsse (90 Tage)",
        dateRange: false
      },
      {
        name: "messstellen_wasserstand_abfluss_mittel",
        label:
          "Tagesmittelwerte des Abflusses (letzter 3-Jahres-Zeitraum bis heute, ungeprüfte Rohdaten)",
        dateRange: false
      },
      {
        name: "messstellen_wasserstand_messwerte_mittel",
        label:
          "Tagesmittelwerte des Wasserstandes (letzter 3-Jahres-Zeitraum bis heute, ungeprüfte Rohdaten)",
        dateRange: false
      }
    ];
  }

  get baseWhere() {
    return ["messst_nr=" + this.id];
  }

  get isDateRange() {
    return this.type && this.type.dateRange;
  }

  get where() {
    return ["messstellennummer=" + this.id];
  }

  mounted() {
    this.type = this.types[0];
  }
}
